const fileDialog = require("file-dialog")

export const getFiles = async (options?: {
  accept: "application/pdf"
}): Promise<File[]> => {
  const filelist = await fileDialog(options)
  return Array.from(filelist)
}
